import type { ReactNode } from 'react';

/**
 * The full-page frame for a QC run's own pages (New QC run, a run's steps): outside the
 * Content card and its tab bar, so the work gets the whole width, with its own scroll area.
 * A plain white page by request — a deliberate exception to the `bg-gradient-page`
 * convention for these image-heavy review pages; the white fills the whole scroll height.
 */
export function QcFullPage({ children }: { children: ReactNode }) {
  return (
    <div className="bg-background h-full min-h-0 overflow-auto">
      <div className="bg-background min-h-full px-6 py-6 lg:px-10 lg:py-8">{children}</div>
    </div>
  );
}
